import React, { useState, useEffect, lazy, Suspense } from "react";
import { Tab, Tabs, Paper, Grid } from "@mui/material";
import TabPanel from "../../Components/TabPanels/TabPanel";
import PolicyDetails from "../../Components/PolicyDetails/PolicyDetails";
import { useSelector } from "react-redux";
import "./ProposalForm.css";
import "./ProposalDetails/ProposerDetailsForm.css";
import LoaderComponent from "../../../Framework/Components/Loader";
const ProposerDetailsForm = lazy(() => import("./ProposalDetails/ProposerDetailsForm"));
const NomineeDetailsForm = lazy(() => import("./NomineeDetails/NomineeDetails"));         
const MedicalDetails = lazy(() => import("./MedicalDetails/MedicalDetails"));
const AditionalInformation = lazy(() => import("./AdditionalInfo/AdditionalInformation"));
const MemberDetailsForm = lazy(() => import("./MemberDetails/MemberDetailsForm"));


const ProposalForm = () => {
  const [, setCurrentTab] = useState(1);
  const [, setProposerData] = useState(null);
  const [, setAdditionalInfo] = useState(null);
  const [, setNomineeData] = useState(null);
  const [, setmodalproposerData] = useState(null);
  const [totalProposalData, setTotalProposaldata] = useState({
    proposer: null,
    additionalData: null,
    member: null,
    nominee: null,
    medical: null,
  });

  const [, setOpen] = useState(false);
  
  const [valueTab, setValueTab] = useState(0);

  useEffect(() => {
    setOpen(true);
  }, []);
  const insurerData = useSelector(
    (state) => state?.healthReducer?.proposerData
  );
  const provider = useSelector(
    (state) => state?.healthReducer?.selectedProvider
  );

  useEffect(() => {
      setmodalproposerData(insurerData);
  }, [insurerData]);

  const handleProposalSubmit = async (data) => {
    setProposerData(data);
    setValueTab(1);
    // const tabValue = provider !=="H"
    // handleNextTab(1);
  };
  const handleAdditionalInformation = async (data) => {
    setAdditionalInfo(data);
  };

  const handleNomineeSubmit = async (data) => {
    setNomineeData(data);
  };

  const handleTabChange = (event, newTab) => {
    setValueTab(newTab);
    setCurrentTab(newTab);
  };

 

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={3}>
          <Paper elevation={3} style={{ padding: 10, height: "100%" }}>
            <PolicyDetails />
          </Paper>
        </Grid>
        {/* Right Content */}
        <Grid item xs={12} sm={9}>
          <Paper elevation={3} style={{ padding: 8, height: "100%" }}>
            <Paper
              elevation={3}
              style={{
                marginBottom: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Tabs
                value={valueTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                indicatorColor="primary"
                textColor="primary"
                sx={{ maxWidth: "100%" }}
              >
                <Tab label="Proposer Details" disabled={valueTab < 1} />
                {/* {(provider === "HDFC" || provider === "CARE") */}
                {!(provider === "bajaj" || provider === "RELIANCE") && (
                  <Tab label="Additional Information" disabled={valueTab < 2} />
                )}
                <Tab
                  label="Member Details"
                  disabled={
                    !(provider === "bajaj" || provider === "RELIANCE")
                      ? // provider === "HDFC" || provider === "CARE"
                        valueTab < 3
                      : valueTab < 2
                  }
                />
                <Tab
                  label="Nominee Details"
                  disabled={
                    // (provider === "HDFC" || provider === "CARE")
                    !(provider === "bajaj" || provider === "RELIANCE")
                      ? valueTab < 4
                      : valueTab < 3
                  }
                />
                <Tab
                  label="Medical Details"
                  disabled={
                    // (provider === "HDFC" || provider === "CARE")
                    !(provider === "bajaj" || provider === "RELIANCE")
                      ? valueTab < 5
                      : valueTab < 4
                  }
                />
              </Tabs>
            </Paper>
            <div className="tabs_contant">
              <TabPanel>
                <Suspense fallback={<LoaderComponent />}>
                  {valueTab === 0 && (
                    <ProposerDetailsForm
                      setValueTab={setValueTab}
                      onSubmitProposal={handleProposalSubmit}
                      totalProposalData={totalProposalData}
                      setTotalProposaldata={setTotalProposaldata}
                    />
                  )}
                </Suspense>
              </TabPanel>
              <TabPanel>
                <Suspense fallback={<LoaderComponent />}>
                  {(provider === "bajaj" || provider === "RELIANCE"
                    ? // (provider !== "HDFC" || provider !== "CARE"
                      valueTab === 1
                    : valueTab === 2) && (
                    <MemberDetailsForm
                      setValueTab={setValueTab}
                      setTotalProposaldata={setTotalProposaldata}
                    />
                  )}
                </Suspense>
              </TabPanel>

              <TabPanel>
                <Suspense fallback={<LoaderComponent />}>
                  {(provider === "bajaj" || provider === "RELIANCE"
                    ? // provider !== "HDFC" || provider !== "CARE"
                      valueTab === 2
                    : valueTab === 3) && (
                    <NomineeDetailsForm
                      onSubmit={handleNomineeSubmit}
                      setValueTab={setValueTab}
                      setTotalProposaldata={setTotalProposaldata}
                    />
                  )}
                </Suspense>
              </TabPanel>
              <TabPanel>
                <Suspense fallback={<LoaderComponent />}>
                  {(provider === "bajaj" || provider === "RELIANCE"
                    ? // provider !== "HDFC" || provider !== "CARE"
                      valueTab === 3
                    : valueTab === 4) && (
                    <MedicalDetails
                      setTotalProposaldata={setTotalProposaldata}
                    />
                  )}
                </Suspense>
              </TabPanel>

              <TabPanel>
                <Suspense fallback={<LoaderComponent />}>
                  {!(provider === "bajaj" || provider === "RELIANCE") &&
                    // provider === "HDFC" || provider === "CARE") &&
                    valueTab === 1 && (
                      <AditionalInformation
                        onSubmitAdditionalInfo={handleAdditionalInformation}
                        setValueTab={setValueTab}
                        setTotalProposaldata={setTotalProposaldata}
                      />
                    )}
                </Suspense>
              </TabPanel>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default ProposalForm;
